
export class UomModel {
    fiItemHdrGuid: string;
    fiItemLineGuid: string;               
    baseUOM:string;
    uom: string;
    uomBaseRatio: number;
    isBaseUom: boolean;
}